let STRIPE_KEY = 'pk_test_4sLhkN2ddEj4JMJUWJd1sIyq';

if (process.env.TARGET === 'production') {
  STRIPE_KEY = 'pk_live_Ac9qpZPDDKykcr8kf3MDS7bX'
}

export default STRIPE_KEY